export const mapRewards = (rewards) => {
  let mappedRewards = {};
  rewards.forEach((reward) => {
    mappedRewards = { ...mappedRewards, [reward.country]: reward.tableBody };
  });
  return mappedRewards;
};
